import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=546c0976&scoped=true&lang=pug&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=546c0976&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c0976",
  null
  
)

export default component.exports